module.exports = __webpack_public_path__ + "static/media/chat06.bc261142.png";